import { render, staticRenderFns } from "./OrganizationIndicators.vue?vue&type=template&id=ab7a0e3e&scoped=true&lang=pug"
import script from "./OrganizationIndicators.vue?vue&type=script&lang=js"
export * from "./OrganizationIndicators.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab7a0e3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab7a0e3e')) {
      api.createRecord('ab7a0e3e', component.options)
    } else {
      api.reload('ab7a0e3e', component.options)
    }
    module.hot.accept("./OrganizationIndicators.vue?vue&type=template&id=ab7a0e3e&scoped=true&lang=pug", function () {
      api.rerender('ab7a0e3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/chatbots/modules/dashboard/OrganizationIndicators.vue"
export default component.exports